import { defineConfig } from '@stackflow/config';

export const config = defineConfig({
    transitionDuration: 350,
    activities: [
        { name: 'MainActivity', route: '/' },
        { name: 'NotOperationModal', route: '/not-operation' },
        { name: 'ItemSoldOutModal', route: 'item-sold-out' },
        { name: 'NotificationActivity', route: '/notifications' },
        { name: 'SignInActivity', route: '/auth/sign-in' },
        { name: 'SignInWithPhoneActivity', route: '/auth/sign-in/phone' },
        { name: 'SignInWithKakaoActivity', route: '/auth/sign-in/kakao' },
        { name: 'SignInWithAppleActivity', route: '/auth/sign-in/apple' },
        { name: 'SignInWithGoogleActivity', route: '/auth/sign-in/google' },
        { name: 'SignUpActivity', route: '/auth/sign-up' },
        { name: 'IdentifySuccessActivity', route: '/identity/done' },
        { name: 'IdentifyFailActivity', route: '/errors/identity-failed' },
        { name: 'TermDetailActivity', route: '/terms' },
        { name: 'BoardActivity', route: '/boards' },
        { name: 'EventActivity', route: '/events/:eventId' },
        { name: 'NoticeActivity', route: '/notices/:noticeId' },
        { name: 'ShopListActivity', route: '/shops' },
        { name: 'ShopLocationBottomSheet', route: '/shops/location' },
        { name: 'ShopPrepareModal', route: '/shops/prepare' },
        { name: 'ShopDetailBottomSheet', route: '/shops/:shopId' },
        { name: 'ItemsActivity', route: '/shops/:shopId/items' },
        { name: 'ItemActivity', route: '/shops/:shopId/items/:itemId' },
        { name: 'ItemNutritionModal', route: '/shops/items/:itemId/nutrition' },
        { name: 'PersonalOptionActivity', route: '/items/:itemId/personal-options' },
        { name: 'OrderActivity', route: '/orders' },
        { name: 'DiscountCouponBottomSheet', route: '/orders/coupons' },
        { name: 'FingerPayActivity', route: '/orders/finger-pay' },
        { name: 'OrderLogsActivity', route: '/orders/logs' },
        { name: 'OrderLogActivity', route: '/orders/logs/:orderNo' },
        { name: 'OrderReceiptActivity', route: '/orders/logs/:orderId/receipt' },
        { name: 'CancelOrderModal', route: '/orders/logs/:orderNo/cancel' },
        { name: 'OrderCompleteActivity', route: '/order/done' },
        { name: 'TossOrderFailActivity', route: '/order/toss/fail' },
        { name: 'TossOrderSuccessActivity', route: '/order/toss/success' },
        { name: 'CustomerServiceActivity', route: '/customer-service' },
        { name: 'InquiryActivity', route: '/customer-service/inquiry' },
        { name: 'InquiryLogActivity', route: '/customer-service/inquiry/logs/:inquiryId' },
        { name: 'CloseInquiryModal', route: '/customer-service/inquiry/logs/:inquiryId/close' },
        { name: 'InquiryCommentModal', route: '/customer-service/inquiry/logs/:inquiryId/comment/confirm' },
        { name: 'InquiryCommentBottomSheet', route: '/customer-service/inquiry/logs/:inquiryId/comment' },
        { name: 'ProjectActivity', route: '/project' },
        { name: 'AccountSettingActivity', route: '/account' },
        { name: 'AccountTerminationActivity', route: '/account/termination' },
        { name: 'NickNameChangeModal', route: '/account/nickname-changed' },
        { name: 'LogoutModal', route: '/account/logout' },
        { name: 'GiftsActivity', route: '/gifts' },
        { name: 'GiftItemActivity', route: '/gift-items/:giftItemId' },
        { name: 'GiftSentActivity', route: '/gifts/send/:giftBoxItemId' },
        { name: 'GiftReceivedActivity', route: '/gifts/received/:giftBoxItemId' },
        { name: 'GiftOrderActivity', route: '/gifts/order' },
        { name: 'GiftOrderCompleteActivity', route: '/gifts/order/complete' },
        { name: 'GiftCancelModal', route: '/gifts/cancel/:giftBoxItemId' },
        { name: 'GiftCanceledModal', route: '/gifts/canceled' },
        { name: 'NewGiftBottomSheet', route: '/gifts/new' },
        { name: 'MyPrepaidCardActivity', route: '/prepaid-cards/my' },
        { name: 'PrepaidCardImagesActivity', route: '/prepaid-cards/images' },
        { name: 'PrepaidCardImageActivity', route: '/prepaid-cards/images/:prepaidCardImageId' },
        { name: 'PrepaidCardManageActivity', route: '/prepaid-cards/manage' },
        { name: 'PrepaidCardChargeActivity', route: '/prepaid-cards/:prepaidCardId/charge' },
        { name: 'PrepaidCardOrderCompleteActivity', route: '/prepaid-cards/order/complete' },
        { name: 'PrepaidCardLogActivity', route: '/prepaid-cards/:prepaidCardId/logs' },
        { name: 'DeleteAllPrepaidCardsModal', route: '/prepaid-cards/manage/delete-all' },
        { name: 'PrepaidCardChargeCompleteActivity', route: '/prepaid-cards/charge/complete' },
        { name: 'MyMenuActivity', route: '/my-menu' },
        { name: 'PointActivity', route: '/points' },
        { name: 'StampsActivity', route: '/stamps' },
        { name: 'StampScopeBottomSheet', route: '/stamps/select-scope' },
        { name: 'StampSortBottomSheet', route: '/stamps/sort' },
        { name: 'CartActivity', route: '/cart/:shopId' },
        { name: 'BarcodeModal', route: '/barcode' },
        { name: 'CouponActivity', route: '/coupons' },
        { name: 'CouponDetailActivity', route: '/coupons/:couponId' },
        { name: 'CouponDownloadModal', route: '/coupons/modal/download' },
        { name: 'ExternalShopModal', route: '/external-shop' },
        { name: 'UserPaymentCancelActivity', route: '/errors/user-cancel' },
        { name: 'PaymentFailedActivity', route: '/errors/payment-failed' },
        { name: 'AlertActivity', route: '/alert' },
        { name: 'PermissionBottomSheet', route: '/permissions' },
        { name: 'LinkActivity', route: '/link' },
        { name: 'TestActivity', route: '/test' },
        { name: 'AppTerminationModal', route: '/app-termination' },
        { name: 'ForceUpdateModal', route: '/force-update' },
        { name: 'AttendanceCheckActivity', route: '/attendance-check' },
        { name: 'EasyCardActivity', route: '/easy-card' },
        { name: 'WithdrawManualActivity', route: '/withdraw-manual' },
        { name: 'TierBenefitsBottomSheet', route: '/tier/benefits' },
        { name: 'TierHistoryActivity', route: '/tier/history' },
        { name: 'TierCalculatedDateBottomSheet', route: '/tier/calculated-cycles' },
        { name: 'NotReadyModal', route: '/not-ready' },
    ],
});
